export default [
  {
    name: 'base',
    data: {},
    items: [
      {
        name: 'googleHomeLedMaskTexture',
        source: '/assets/googleHomeLedMask.png',
        type: 'texture'
      },
      {
        name: 'threejsJourneyLogoTexture',
        source: '/assets/threejsJourneyLogoTexture.png',
        type: 'texture'
      },
      {
        name: 'googleHomeLedsModel',
        source: '/assets/googleHomeLedsModel.glb',
        type: 'model'
      },
      {
        name: 'topChairModel',
        source: '/assets/topChairModel.glb',
        type: 'model'
      },
      {
        name: 'elgatoLightModel',
        source: '/assets/elgatoLightModel.glb',
        type: 'model'
      },
      {
        name: 'coffeeSteamModel',
        source: '/assets/coffeeSteamModel.glb',
        type: 'model'
      },
      {
        name: 'monitorScreenModel',
        source: '/assets/monitorScreenModel.glb',
        type: 'model'
      },
      {
        name: 'macScreenModel',
        source: '/assets/macScreenModel.glb',
        type: 'model'
      },
      { name: 'bakedTexture', source: '/assets/baked.jpg', type: 'texture' },
      { name: 'roomModel', source: '/assets/roomModel.glb', type: 'model' }
    ]
  }
];
